import React, {FunctionComponent} from "react";
import {FilePreviewerProps} from "../FilePreview";

export const ImagePreview: FunctionComponent<FilePreviewerProps> = (props) => {
    return (
        <img src={props.file?.url} className='preview-image' alt="file-preview"/>
    );
};